<template>

  <div>

    <!-- Filters -->
    <!--
    <Carts-list-filters
      :role-filter.sync="roleFilter"
      :plan-filter.sync="planFilter"
      :status-filter.sync="statusFilter"
      :role-options="roleOptions"
      :plan-options="planOptions"
      :status-options="statusOptions"
    />-->

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Gösterim Sayısı</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>sonuç</label>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="fetchCarts"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Sonuç bulunamadı"
        :sort-desc.sync="isSortDirDesc"
      >
      
      <template #cell(influencer)="data">
        <template v-if="data.item.influencer && data.item.influencer.id">
          <influencer-link-btn :id="data.item.influencer.id" :name="data.item.influencer.username" />
        </template>
        <template v-else>
          <p>Bilinmeyen Fenomen</p>
        </template>
      </template>

      <template #cell(link)="data">
        <template v-if="data.item.link && data.item.link.id">
          <campaign-link-btn :name="data.item.link.campaign_name" :route="getLinkName(data.item.link)" />
        </template>
        <template v-else>
          <p>Bilinmeyen Paylaşım</p>
        </template>
      </template>
      
      <template #cell(total_amount)="data">
            {{ priceFormat(data.item.total_amount) }} 
      </template>

      <template #cell(show_details)="data">

        <!-- As `data.showDetails` is one-way, we call the toggleDetails function on @change -->
        <b-form-checkbox
        v-model="data.detailsShowing"
        @change="data.toggleDetails"
        >
        {{ data.detailsShowing ? 'Detayı Gizle' : 'Detayı Gör' }}
        </b-form-checkbox>
        </template>

      <template #cell(product_name)="data">
        <a :href="data.item.url" target="_blank" v-if="data.item.url.includes('www')"> {{ data.item.product_name }} </a>
        <a :href="$store.state.user.customerInfo.domain+data.item.url" target="_blank" v-else>{{ data.item.product_name }} </a>
    </template>


    <template #cell(created_date)="data">
        {{ formatDate(data.item.created_date) }}
      </template>

      <template #cell(created_time)="data">
      {{ formatDateTime(data.item.created_date) }}
    </template>


    <template #cell(link_type)="data">
        <b> {{ getTypeName(data.item.link_type) }}</b> 
    </template>
    
    <template #cell(platform)="data">
        <b> {{ data.item.platform.name }}</b> 
    </template>

      <!-- full detail on click -->
      <template #row-details="data">
      <b-card class="border border-primary">

        <b-card-body
          class="invoice-padding pt-0"
        >
          <b-row class="invoice-spacing">
            
            <!-- Col: Payment Details -->
            <b-col
              xl="6"
              cols="12"
            >
              <div>
                <h6 class="mb-2">
                  Cihaz Bilgisi:
                </h6>
                <p>
                  <b>Cihaz Bilgisi:</b>
                  <span>{{ data.item.browser_info }}</span>
                </p>
                <p>
                  <b>Tarayıcı:</b>
                  <span>{{ data.item.browser_name }}</span>
                </p>
                <p>
                  <b>Cihaz Tipi:</b>
                  <span>{{ data.item.device_type }}</span>
                </p>
                <p>
                  <b>Cihaz Modeli:</b>
                  <span>{{ data.item.device_model }}</span>
                </p>
                <p>
                  <b>Ekran Bilgisi:</b>
                  <span>{{ data.item.screen_width }}</span>
                </p>
              </div>
            </b-col>

          </b-row>
        </b-card-body>
        
          <!--
          <b-button
            size="sm"
            variant="outline-secondary"
            @click="data.toggleDetails"
          >
            Gizle
          </b-button>
        -->
      </b-card>
      </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalCarts"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>

  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BFormCheckbox, BTableLite
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import CartsListFilters from '@/components/cart/CartsListFilters.vue'
import CampaignLinkBtn from '@/components/link/CampaignLinkBtn.vue'
import useCartsList from '@/components/cart/useCartsList'
import InfluencerLinkBtn from '@/components/link/InfluencerLinkBtn.vue'

export default {
  components: {
    CartsListFilters,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormCheckbox,
    BTableLite,

    vSelect,
    CampaignLinkBtn,
    InfluencerLinkBtn
  },
  methods: {
    getLinkName(item) {
      let route = {
        name: '',
        params: {
          id: item.id
        }
      };

      if (item.type == 0) {
        if (item.links && item.links.length > 0) {
          route.name = "campaign-group-detail";
          route.params.id = item.group_id;
        } else {
          route.name = "campaign-detail";
        }
      } else if (item.type == 1) {
        route.name = "story-detail";
      } else if (item.type == 2) {
        route.name = "sms-detail";
      } else if (item.type == 4) {
        route.name = "whatsapp-detail";
      } else if (item.type == 3) {
        route.name = "bio-detail";
        route.params.platform_id = item.platform.id;
      } else{
        route.name = "campaign-detail";
      }

      return route;
    },
    getTypeName(type) {
      switch(type) {
        case 0:
          return 'Link Paylaşımı';
        case 1:
          return 'Story Paylaşımı';
        case 2:
          return 'SMS Paylaşımı';
        case 3:
          return 'Bio Paylaşımı';
        case 4:
          return 'Whatsapp Paylaşımı';
        default:
          return 'Bilinmeyen Tür';
      }
    },
    isGroupItem(item){
      return item.links && item.links.length > 0
    }
  },
  setup() {


    const {
      fetchCarts,
      tableColumns,
      perPage,
      currentPage,
      totalCarts,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      
    } = useCartsList()

    return {


      fetchCarts,
      tableColumns,
      perPage,
      currentPage,
      totalCarts,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // Filter
      avatarText,

    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
